<template>
  <div class="tender-status__status">
    <span class="tender-title__subtitle">{{ $t('search-filters.status.name') }}</span>
    <TenderStatusTag :status="status" />
  </div>
</template>

<script>
import TenderStatusTag from '@/components/page-tender-details/TenderStatusTag.vue';

export default {
  name: 'TenderStatus',
  props: {
    status: String,
  },
  components: {
    TenderStatusTag,
  },
};
</script>
